<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                        <TabPane label="各班级安装大屏详情" name="classInstallScreenDetails"></TabPane>
                        <TabPane label="绑定大屏班级详情" name="bindScreenClassNum"></TabPane>
                        <TabPane label="活跃大屏使用详情" name="activeScreenUseDetails"></TabPane>
                        <TabPane label="大屏重复绑定详情" name="screenRepeatBind" v-if="isShowRemind==1"></TabPane>
                        <TabPane label="活跃教师使用详情" name="activeTeaUseDetails"></TabPane>
                        <TabPane label="活跃学生使用详情" name="activeStuUseDetails"></TabPane>
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        :placeholder="placeholder"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--班级安装大屏详情-->
                <div class="table-wrapper-data" v-if="dataIndex==0" ref="cardTableRef">
                    <Table :columns="insScreenColumn" :data="classInstallScreenList"></Table>
                </div>
                <!--活跃大屏使用详情-->
                <div class="table-wrapper-data" v-if="dataIndex==1">
                    <Table :columns="activeScreenColumn" :data="activeScreenUseList"></Table>
                </div>
                <!--大屏重复绑定详情-->
                <div class="table-wrapper-data" v-if="dataIndex==2">
                    <Table :columns="screenRepeatBindColumn" :data="screenRepeatBindList"></Table>
                </div>
                <!--活跃教师数量-->
                <div class="table-wrapper-data" v-if="dataIndex==3">
                    <Table :columns="activeTeaNumColumn" :data="activeTeaNumList"></Table>
                </div>
                <!--活跃学生数量-->
                <div class="table-wrapper-data" v-if="dataIndex==4">
                    <Table :columns="activeStuNumColumn" :data="activeStuNumList"></Table>
                </div>
                <!--绑定大屏班级数-->
                <div class="table-wrapper-data" v-if="dataIndex==5">
                    <Table :columns="bindScreenClassColumn" :data="bindScreenClassList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main"
                     v-if="dataIndex==0||dataIndex==1||dataIndex==3||dataIndex==4||dataIndex==5">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {
        getClassDiskDataList,
        getScreenDataList,
        screenRepeatList,
        getSchoolTeacherDataList,
        getSchoolStudentDataList,
        getAllClassesDisk
    } from "../../../service/api.js";
    import dateSelect from "../../../components/dateSelect.vue";

    export default {
        name: "data-details-tab",
        data () {
            return {
                schoolId: this.$route.query.schoolId,//学校id
                schoolName: this.$route.query.schoolName,//学校名称
                selfStartDate: this.$route.query.parentalStartDate,//一级页面传来的开始时间
                selfEndDate: this.$route.query.parentalEndDate,//一级页面传来的结束时间
                parentalStartDate: this.$route.query.parentalStartDate,//记住页面传来的开始时间
                parentalEndDate: this.$route.query.parentalEndDate,//记住页面传来的结束时间
                isShowRemind: this.$route.query.isShowRemind,//结束时间
                tabsName: this.$route.query.tabsName,//tab名称
                curSeleMainStartDate: this.$route.query.curSeleMainStartDate,//三级页面传来的开始时间
                curSeleMainEndDate: this.$route.query.curSeleMainEndDate,//三级页面传来的结束时间
                type: this.$route.query.type,//tab名称
                keyWord: "",//关键字
                page: 1,//当前页面
                limit: 10,//页面数据数量
                total: 0,//页面数据总数
                pageCount: 0,//页数
                dataIndex: 0,//默认显示班级安装大屏详情数据
                classInstallScreenList: [],//班级安装大屏集合
                activeScreenUseList: [],//活跃大屏使用详情
                screenRepeatBindList: [],//大屏重复绑定集合
                activeTeaNumList: [],//活跃教师集合
                activeStuNumList: [],//活跃学生集合
                bindScreenClassList: [],//绑定大屏班级数
                placeholder:"",//搜索框提示语
                cardWrapperStyle:{
                    height:"700px"
                },
                insScreenColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "班级名称",
                        key: "className",
                        align: "center"
                    },
                    {
                        title: "硬盘ID",
                        key: "diskName",
                        align: "center"
                    },
                    {
                        title: "mac",
                        key: "mac",
                        align: "center"
                    },
                    {
                        title: "使用天数",
                        key: "day",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "活跃大屏具体使用详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.gotoDataDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.day
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "creat_time",
                        align: "center"
                    }
                ],
                activeScreenColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "班级名称",
                        key: "className",
                        align: "center"
                    },
                    {
                        title: "硬盘ID",
                        key: "diskId",
                        align: "center"
                    },
                    {
                        title: "版本号",
                        key: "product_version",
                        align: "center"
                    },
                    {
                        title: "使用天数",
                        key: "day",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "活跃大屏具体使用详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.gotoDataDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.day
                                )
                            ]);
                        }
                    }
                ],
                screenRepeatBindColumn: [
                    {
                        title: "班级名称",
                        key: "className",
                        align: "center"
                    },
                    {
                        title: "硬盘ID",
                        key: "diskId",
                        align: "center"
                    },
                    {
                        title: "mac",
                        key: "mac",
                        align: "center"
                    },
                    {
                        title: "创建时间",
                        key: "time",
                        align: "center"
                    }
                ],
                activeTeaNumColumn: [
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "教师使用场景详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.goUseDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.fullName
                                )
                            ]);
                        }
                    },
                    {
                        title: "科目名称",
                        key: "subName",
                        align: "center"
                    },
                    {
                        title: "手机号码",
                        key: "mobile",
                        align: "center"
                    },
                    {
                        title: "使用时间",
                        key: "day",
                        align: "center"
                    }
                ],
                activeStuNumColumn: [
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "教师使用场景详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.goUseDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.fullName
                                )
                            ]);
                        }
                    },
                    {
                        title: "手机号码",
                        key: "mobile",
                        align: "center"
                    },
                    {
                        title: "使用时间",
                        key: "day",
                        align: "center"
                    }
                ],
                bindScreenClassColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "班级名称",
                        key: "className",
                        align: "center"
                    },
                    {
                        title: "硬盘ID",
                        key: "diskName",
                        align: "center"
                    },
                    {
                        title: "mac",
                        key: "mac",
                        align: "center"
                    },
                    {
                        title: "使用天数",
                        key: "day",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "活跃大屏具体使用详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "14px"
                                        },
                                        on: {
                                            click: () => {
                                                this.gotoDataDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.day
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "creat_time",
                        align: "center"
                    }
                ],
            }
        },
        components: {
            //时间选择组件
            dateSelect
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.type == 1 ? this.curSeleMainStartDate : this.parentalStartDate,
                        endDate: this.type == 1 ? this.curSeleMainEndDate : this.parentalEndDate,
                    }
                });
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                this.pageCount = 0;
                this.tabsName = tabsName;
                if (tabsName == 'classInstallScreenDetails') {
                    //显示各班级安装大屏详情,获取班级安装大屏详情数据
                    this.dataIndex = 0;
                    this.placeholder="支持硬盘ID,mac关键字搜索";
                    this.queryClassInstallScreenDetails();
                } else if (tabsName == 'activeScreenUseDetails') {
                    //显示活跃大屏使用详情,获取活跃大屏使用详情数据
                    this.dataIndex = 1;
                    this.placeholder="支持硬盘ID关键字搜索";
                    this.queryActiveScreenUseDetailsData();
                } else if (tabsName == 'screenRepeatBind') {
                    //显示大屏重复绑定详情,获取大屏重复绑定数据
                    this.dataIndex = 2;
                    this.placeholder="支持硬盘ID关键字搜索";
                    this.queryScreenRepeatBindData();
                } else if (tabsName == 'activeTeaUseDetails') {
                    //显示活跃教师使用详情,获取活跃教师数据
                    this.dataIndex = 3;
                    this.placeholder="支持用户名称、手机号码关键字搜索";
                    this.queryActiveTeaList();
                } else if (tabsName == 'activeStuUseDetails') {
                    //显示活跃学生使用详情，获取活跃学生数据
                    this.dataIndex = 4;
                    this.placeholder="支持用户名称、手机号码关键字搜索";
                    this.queryActiveStuList();
                } else if (tabsName == 'bindScreenClassNum') {
                    //显示活跃学生使用详情，获取活跃学生数据
                    this.dataIndex = 5;
                    this.placeholder="支持硬盘ID,mac关键字搜索";
                    this.queryBindScreenClassList();
                }
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                if (this.dataIndex == 0) {
                    //获取班级安装大屏详情数据
                    this.queryClassInstallScreenDetails();
                } else if (this.dataIndex == 1) {
                    //获取活跃大屏使用详情数据
                    this.queryActiveScreenUseDetailsData();
                } else if (this.dataIndex == 2) {
                    //获取大屏重复绑定数据
                    this.queryScreenRepeatBindData();
                } else if (this.dataIndex == 3) {
                    //获取活跃教师数据
                    this.queryActiveTeaList();
                } else if (this.dataIndex == 4) {
                    //获取活跃学生数据
                    this.queryActiveStuList();
                } else if (this.dataIndex == 5) {
                    //获取绑定大屏班级数据
                    this.queryBindScreenClassList();
                }
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                if (this.dataIndex == 0) {
                    //获取班级安装大屏详情数据
                    this.queryClassInstallScreenDetails();
                } else if (this.dataIndex == 1) {
                    //获取活跃大屏使用详情数据
                    this.queryActiveScreenUseDetailsData();
                } else if (this.dataIndex == 2) {
                    //获取大屏重复绑定数据
                    this.queryScreenRepeatBindData();
                } else if (this.dataIndex == 3) {
                    //获取活跃教师数据
                    this.queryActiveTeaList();
                } else if (this.dataIndex == 4) {
                    //获取活跃学生数据
                    this.queryActiveStuList();
                } else if (this.dataIndex == 5) {
                    //获取绑定大屏班级数据
                    this.queryBindScreenClassList();
                }
            },
            /**
             *获取班级安装大屏详情数据
             */
            async queryClassInstallScreenDetails () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getClassDiskDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.classInstallScreenList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                            // _this.$nextTick(() => {
                            //     _this.cardWrapperStyle.height = _this.$refs.cardTableRef.clientHeight +163 + "px";
                            // });
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取活跃大屏使用详情数据
             */
            async queryActiveScreenUseDetailsData () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getScreenDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeScreenUseList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏重复绑定数据
             */
            async queryScreenRepeatBindData () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    keyWord: _this.keyWord
                };
                await screenRepeatList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.screenRepeatBindList = data;
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取活跃教师数据
             */
            async queryActiveTeaList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolTeacherDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeTeaNumList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取活跃教师数据
             */
            async queryActiveStuList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolStudentDataList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeStuNumList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取绑定大屏班级数量
             */
            async queryBindScreenClassList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.selfStartDate,
                    endTime: _this.selfEndDate,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getAllClassesDisk(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.bindScreenClassList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 跳转到活跃大屏具体使用详情
             */
            gotoDataDetails (row) {
                this.$router.push({
                    name: "scrUserDetai",
                    query: {
                        schoolId: this.schoolId,
                        selfStartDate: this.selfStartDate,//本页面选择的开始时间
                        selfEndDate: this.selfEndDate,//本页面选择的结束时间
                        parentalStartDate: this.parentalStartDate,//主页面选择的开始时间
                        parentalEndDate: this.parentalEndDate,//主页面选择的结束时间
                        schoolName: this.schoolName,
                        tabsName: this.tabsName,
                        isShowRemind: this.isShowRemind,
                        diskId: this.dataIndex == 1 ? row.diskId : row.diskName
                    }
                });
            },
            /**
             * 跳转到用户具体使用详情
             */
            goUseDetails (row) {
                if (this.dataIndex == 3) {
                    this.$router.push({
                        name: "activeTeaDetails",
                        query: {
                            schoolId: this.schoolId,
                            selfStartDate: this.selfStartDate,//本页面选择的开始时间
                            selfEndDate: this.selfEndDate,//本页面选择的结束时间
                            parentalStartDate: this.parentalStartDate,//主页面选择的开始时间
                            parentalEndDate: this.parentalEndDate,//主页面选择的结束时间
                            schoolName: this.schoolName,
                            tabsName: this.tabsName,
                            isShowRemind: this.isShowRemind,
                            teaName: 'notAddTime',
                            userId: row.user_id,
                            sourceType: 0,//跳转的页面类型
                        }
                    });
                } else if (this.dataIndex == 4) {
                    this.$router.push({
                        name: "activeStudentDetails",
                        query: {
                            schoolId: this.schoolId,
                            selfStartDate: this.selfStartDate,//本页面选择的开始时间
                            selfEndDate: this.selfEndDate,//本页面选择的结束时间
                            parentalStartDate: this.parentalStartDate,//主页面选择的开始时间
                            parentalEndDate: this.parentalEndDate,//主页面选择的结束时间
                            schoolName: this.schoolName,
                            tabsName: this.tabsName,
                            isShowRemind: this.isShowRemind,
                            userId: row.user_id
                        }
                    });
                }
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.selfStartDate = startDate;
                this.selfEndDate = endDate;
                if (this.dataIndex == 0) {
                    //获取班级安装大屏详情数据
                    this.queryClassInstallScreenDetails();
                } else if (this.dataIndex == 1) {
                    //获取活跃大屏使用详情数据
                    this.queryActiveScreenUseDetailsData();
                } else if (this.dataIndex == 2) {
                    //获取大屏重复绑定数据
                    this.queryScreenRepeatBindData();
                } else if (this.dataIndex == 3) {
                    //获取活跃教师数据
                    this.queryActiveTeaList();
                } else if (this.dataIndex == 4) {
                    //获取活跃学生数据
                    this.queryActiveStuList();
                } else if (this.dataIndex == 5) {
                    //获取绑定大屏班级数据
                    this.queryBindScreenClassList();
                }
            }
        },
        mounted () {
            //选择展示不同的tab数据信息
            this.changeDataDetailsIndex(this.tabsName);
            //记住主页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.parentalStartDate, this.parentalEndDate);
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";

    .laypage_main {
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
